import { render, staticRenderFns } from "./MatchConsentStep.vue?vue&type=template&id=e1dea4b2"
import script from "./MatchConsentStep.vue?vue&type=script&lang=js"
export * from "./MatchConsentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports